<template>
    <div class="flex flex-col w-full">
        <label v-if="label" :for="inputId" class="font-bold mb-1">{{ label }}</label>

        <Multiselect
            v-model="inputValue"
            tag-placeholder="No tag with this name"
            :placeholder="placeholder"
            :options="options"
            :multiple="true"
            :taggable="true"
            @input="onChange"
        ></Multiselect>
    </div>
</template>
<script>
import FormInputMixin from './form_inputs_mixin';

export default {
    components: {
        Multiselect: () => import(/* webpackChunkName: "lazy-loaded/vue-multiselect" */ 'vue-multiselect')
    },

    mixins: [FormInputMixin],

    props: {
        value: {
            type: Array,
            default: () => {
                return [];
            }
        },
        options: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },

    data() {
        return {
            inputValue: this.value
        };
    },

    watch: {
        value: function() {
            this.inputValue = this.value;
        }
    },

    methods: {
        onChange() {
            this.$emit('input', this.inputValue);
        }
    }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.multiselect__tags {
    min-height: auto;
    display: block;
    padding: 0.75rem 1rem;
    border-radius: 5px;
    border: 1px solid #edf2f7;
    background: #edf2f7;
    font-size: 16px;
}

.multiselect__placeholder {
    @apply mb-0 p-0;
}

.multiselect--active:not(.multiselect--above) .multiselect__tags {
    @apply p-0;
}

.multiselect__select {
    height: 50px;
}

.multiselect__tag {
    @apply bg-teal-600 mb-0;
}

.multiselect__input,
.multiselect__single {
    @apply m-0 py-3 px-4 leading-normal min-h-0;
}
</style>
